import { Box, HStack, Text } from "@chakra-ui/react";

import { FragmentType, getFragmentData, graphql } from "@/__generated__";
import CopyableText from "@/components/CopyableText";

const UserProfileToken_User = graphql(`
  fragment UserProfileToken_User on User {
    id
    authenticationToken
  }
`);

interface Props {
  user: FragmentType<typeof UserProfileToken_User>;
}

export default function Token({ ...props }: Props) {
  const user = getFragmentData(UserProfileToken_User, props.user);
  const token = user.authenticationToken;

  return (
    <Box>
      {token && (
        <>
          <Text mb={2}>API Token</Text>
          <HStack justifyContent="space-between">
            <CopyableText
              displayText={"********************"}
              textToCopy={() => token || ""}
              tooltip={"Copy API Token to the clipboard"}
              tooltipProps={{ openDelay: 300 }}
            />
          </HStack>
        </>
      )}
    </Box>
  );
}
